import React from "react";
import { Alert, Snackbar, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useAppDispatch, useAppSelector } from "@store/index";
import { hideSnackbar, snackbarSelector } from "@store/slices/snackbar-slice";

/**
 * Global SnackBar component managed by Redux
 * This component should be placed at the top level of the app
 */
const HPSnackBar: React.FC = () => {
  const dispatch = useAppDispatch();
  const { open, message, severity, autoHideDuration, action } =
    useAppSelector(snackbarSelector);

  const handleClose = (_?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(hideSnackbar());
  };

  const handleActionClick = () => {
    if (action?.onClick) {
      action.onClick();
      handleClose();
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{
          width: "100%",
          alignItems: "center",
          "& .MuiAlert-message": {
            padding: "8px 0",
            display: "flex",
            alignItems: "center",
          },
          "& .MuiAlert-action": {
            padding: "0",
            marginRight: "0",
            marginLeft: "8px",
            alignItems: "center",
          },
        }}
        action={
          action ? (
            <Button
              color="inherit"
              size="small"
              onClick={handleActionClick}
              startIcon={
                action.label === "Retry" ? (
                  <RefreshIcon sx={{ fontSize: "18px" }} />
                ) : action.label === "Edit" ? (
                  <EditIcon sx={{ fontSize: "18px" }} />
                ) : undefined
              }
              sx={{
                textTransform: "none",
                fontWeight: 600,
                minWidth: "auto",
                padding: "6px 12px",
              }}
            >
              {action.label}
            </Button>
          ) : undefined
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default HPSnackBar;
